import React, { ReactNode } from 'react'
import s from './AlertBar.module.css'

type AlertBarProps = {
  title: string | ReactNode
  subTitle: string | ReactNode
  Icon: React.ElementType
  onCtaClick?: () => void
  className?: string
  cancelText?: string
  onCancelClick?: () => void
  ctaText?: string
  alertFooter?: ReactNode
  contentClassName?: string
}

export const AlertBar = ({
  title,
  subTitle,
  Icon,
  ctaText,
  cancelText,
  className,
  onCtaClick,
  onCancelClick,
  contentClassName
}: AlertBarProps): JSX.Element => {
  return (
    <div className={`${s.alertBar} ${className}`}>
      <span className={`${s.content} ${contentClassName}`}>
        <span className={s.icon}>
          <Icon />
        </span>
        <span>
          <h3 className={s.title}>{title}</h3>
          <p className={s.subTitle}>{subTitle}</p>
        </span>
      </span>
      <span className={s.buttons}>
        {cancelText && onCancelClick && (
          <button className={s.secondaryButton} onClick={onCancelClick}>
            {cancelText}
          </button>
        )}
        {ctaText && (
          <button className={s.primaryButton} onClick={onCtaClick}>
            {ctaText}
          </button>
        )}
      </span>
    </div>
  )
}
